import { Typography } from "@material-ui/core"
import styled from "styled-components"

export const StyledHeaderH2 = styled(Typography).attrs({ variant: "h2" })<{
  $position?: string
  $margin?: number
  $fontSize?: string
  $fontWeight?: string
  $lineHeight?: string
}>`
  ${(p) => p.$position && `text-align: ${p.$position}`};
  ${(p) => p.$margin && `margin-top: ${p.$margin}`}px;
  ${(p) => p.$lineHeight && `line-height: ${p.$lineHeight}`};
  font-size: ${(p) => (p.$fontSize ? `${p.$fontSize}px` : "24px")};
  font-weight: ${(p) => (p.$fontWeight ? p.$fontWeight : "400")};
`

export const StyledSubtitle = styled(Typography).attrs({
  variant: "h3",
})<{ $margin: number; $fontWeight?: string }>`
  font-size: 20px;
  margin-top: ${(p) => p.$margin}px;
  font-weight: ${(p) => (p.$fontWeight ? p.$fontWeight : "bold")};
`

export const StyledHeaderSubtitle = styled(Typography).attrs({
  variant: "h3",
})<{ $position?: string; $margin?: number }>`
  margin-top: ${(p) => (p.$margin ? `${p.$margin}px` : "20px")};
  ${(p) => p.$position && `text-align: ${p.$position}`};
  letter-spacing: 0;
`

export const StyledBody = styled(Typography).attrs({ variant: "body1" })<{
  $margin?: number
  $position?: string
  $fontSize?: string
}>`
  margin-top: ${(p) => (p.$margin ? `${p.$margin}px` : "10px")};
  ${(p) => p.$position && `text-align: ${p.$position}`};
  font-size: ${(p) => (p.$fontSize ? `${p.$fontSize}px` : "18px")};
`

export const StyledH3 = styled(Typography).attrs({ variant: "h3" })`
  margin-top: 40px;
  font-family: "OENaPro";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.05em;
  color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.down("sm")} {
    max-width: 300px;
  }
`

export const StyledUl = styled.ul<{ $padding?: number }>`
  margin: 0px;
  ${(p) => p.$padding && `padding-right: ${p.$padding}px`};
`
export const StyledLi = styled.li<{ $margin?: number }>`
  margin-top: ${(p) => (p.$margin ? `${p.$margin}px` : "0px")};
  &::marker {
    font-size: 10px;
  }
`

export const StyledLink = styled.a<{
  $margin?: number
  $display?: string
  $color?: string
  $fontSize?: number
}>`
  text-decoration: underline;
  ${(p) => p.$margin && `margin-top: ${p.$margin}px`};
  color: ${(p) => (p.$color ? p.$color : p.theme.colors.mazdaRed)};
  ${(p) => p.$display && `display: ${p.$display}`};
  ${(p) => p.$fontSize && `font-size: ${p.$fontSize}px`}
`

export const StyledSmallText = styled(Typography).attrs({ variant: "h3" })<{
  $margin?: number
  $fontWeight?: string
}>`
  font-size: 14px;
  margin-top: ${(p) => (p.$margin ? `${p.$margin}px` : "10px")};
  ${(p) => p.$fontWeight && `font-weight: ${p.$fontWeight}`}
`

export const StyledBody2 = styled(Typography).attrs({ variant: "body2" })<{
  $fontSize?: number
  $margin?: number
}>`
  ${(p) => p.$fontSize && `font-size: ${p.$fontSize}px`};
  ${(p) => p.$margin && `margin-top: ${p.$margin}px`};
`

export const StyledTable = styled.table<{ $width?: string }>`
  border-collapse: collapse;
  text-align: right;
  margin-top: 10px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    display: block;
    width: ${(p) => (p.$width ? p.$width : "350px")};
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ${(p) => p.theme.breakpoints.down("xs")} {
    width: ${(p) => (p.$width ? p.$width : "90vw")};
  }
`
export const StyledThead = styled.thead``

export const StyledTr = styled.tr`
  font-weight: normal;
  td:first-child {
    font-size: 16px;
    color: ${(p) => p.theme.colors.black};
  }
`

export const StyledTh = styled.th`
  color: ${(p) => p.theme.colors.black};
  background: ${(p) => p.theme.colors.white};
  border: 1px solid ${(p) => p.theme.colors.darkGrey};
  padding: 7px 7px;
  font-size: 16px;
  line-height: 1;
  font-weight: normal;
`

export const StyledTd = styled.td`
  padding: 7px 5px;
  border: 1px solid ${(p) => p.theme.colors.darkGrey};
  font-size: 18px;
`
